import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import COLORS from '~/constants/colors';
import { FONT_SIZES } from '~/constants/typography';
import FramedView from '~/components/FramedView';
import Button from '~/components/buttons/Button';
import Title from '~/components/titles/Title';
import Divider from '~/components/flow/Divider';
import Break from '~/components/flow/Break';
import { stopEventEffects } from '~/utils';

interface NotFoundProps {
  withCode?: boolean;
}

function NotFound({ withCode = false }: NotFoundProps): ReactElement {
  const navigate = useNavigate();
  const handleGoBack = (event) => {
    stopEventEffects(event);
    navigate(-1);
  };

  // Styling
  const notFoundStyle = {
    width: 'min(45em, 82.5vw)',
  };
  const frameColors: [string, string] = [
    COLORS.waikawaGray,
    COLORS.waikawaGray,
  ];
  const buttonStyle = {
    width: '9em',
    margin: '0 0.25em 0.38em',
    boxShadow: `-0.1em 0.1em ${COLORS.black25}`,
    borderStyle: 'none',
    fontSize: FONT_SIZES.text,
  };

  return (
    <FramedView accent colors={frameColors} style={notFoundStyle}>
      <Title>Not Found</Title>
      <Divider />
      You&apos;ve discovered the hidden treasure of nothing. But forget not the
      wisdoms of old.
      {withCode
        ? ' The requested chart may have been deleted. '
        : " Code requires time and effort, a kindred to history's greatest towers and stone scultures. Do not take that for granite and know there may be something here in the future. "}
      For now, please check your spelling in the address bar.
      <Break />
      <Button label="Go Back" callback={handleGoBack} style={buttonStyle} />
    </FramedView>
  );
}

export default NotFound;
